import React from 'react';
import { WrapperContainer } from './styled';

function WrapperFeatures(props) {
  const { featureData, isDetergentProduct } = props;

  return (
    <WrapperContainer isDetergentProduct={isDetergentProduct}>
      {featureData?.map((ele, index) => {
        return (
          <div key={`wrapper_${index}`} className="featuresInner"
           style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center'
        }}>
            <img src={ele.image} alt="" />
           <p style={{ whiteSpace: 'pre-line' }}>{ele.text}</p>
      
           
          </div>
        );
      })}
    </WrapperContainer>
  );
}

export default WrapperFeatures;
